import types from '../types/terms'

const initialRoot = {
  deposit: {
    address: {
      address_string: "",
      apartment: "",
      city: "Comuna 6",
      comment: "",
      floor: "",
      number: "145",
      postal_code: "",
      province: "CABA",
      street: "Arturo Jauretche"
    },
    card_last_digits: "",
    card_type: "",
    cubic_m: 1,
    cubic_m_price: 450,
    datetime: "2021-01-07 13:30:00",
    discount_code: "",
    full_address_string: "",
    guid: "",
    items: [],
    no_transport_required: false,
    operation_number: 0,
    payment_type: "offline",
    status: "confirmed",
    total_storage_cost: 0,
    transport_cost: 0,
    type: "m3"
  },
  loadingDeposit: false,
  loadingTC: false,
  loadingEmail: false,
  successTC: false,
  token: '',
  errorDeposit: '',
  errorTC: '',
  errorEmail: ''
}

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.GET_DEPOSIT_GUID_REQUEST:
      return {
        ...state,
        loadingDeposit: true
      }
    case types.GET_DEPOSIT_GUID_SUCCESS:
      return {
        ...state,
        loadingDeposit: false,
        deposit: action.payload.deposit
      }
    case types.GET_DEPOSIT_GUID_FAILURE:
      return {
        ...state,
        errorDeposit: action.payload.error,
        loadingDeposit: false
      }
    case types.VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        loadingEmail: true,
        errorTerms: '',
      }
    case types.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        loadingEmail: false,
      }
    case types.VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        loadingEmail: false,
        errorEmail: action.payload.error,
      }
    case types.ACCEPT_TYC_REQUEST:
      return {
        ...state,
        loadingTC: true,
        error: '',
      }
    case types.ACCEPT_TYC_SUCCESS:
      return {
        ...state,
        successTC: true,
        loadingTC: false,
      }
    case types.ACCEPT_TYC_FAILURE:
      return {
        ...state,
        loadingTC: false,
        errorTC: action.payload.error,
      }
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/termsDeposit/reducers/terms.js